import { config } from '../../config/config';
import { API_STREAMS, API_STREAMS_ADMIN, apiHeaders, q } from './apiAuth';

const PORT_DB = config.API.PORT_DB;

export const fetchLists = async (table_data, email_data, token) => {
    try {
        const response = await fetch(`${PORT_DB}/Username/${table_data}/${email_data}`, {
            method: "GET",
            headers: { "x-access-token": token },
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const getProjectsWell = async (client, project) => {
    try {
        //port_streaming/selectopprojectwells/client/project
        const response = await fetch(`${API_STREAMS}/selectopprojectwells/${client}/${project}`, {
            method: "GET",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const getTypeOfStream = async (product) => {
    try {
        const response = await fetch(`${API_STREAMS}/selectdashboardstreams/${product}`, {
            method: "GET",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const createStreamPath = async (product, client, project, streamType, wellName, streamPath) => {
    try {
        const response = await fetch(`${API_STREAMS}/createstreampath/${product}/${client}/${project}/${streamType}/${wellName}?streamingpath=${q(streamPath)}`, {
            method: "POST",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const deleteStream = async (product, client, project, streamType, wellName, streamPath) => {
    try {
        const response = await fetch(`${API_STREAMS}/deletestream/${product}/${client}/${project}/${streamType}/${wellName}`, {
            method: "DELETE",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const startStream = async (product, client, project, streamType, wellName, streamPath) => {
    try {
        const response = await fetch(`${API_STREAMS}/startstream/${product}/${client}/${project}/${streamType}/${wellName}`, {
            method: "POST",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const updateStreamPath = async (product, client, project, streamType, wellName, newStreamPath) => {
    try {
        const response = await fetch(`${API_STREAMS}/updatestreampath/${product}/${client}/${project}/${streamType}/${wellName}?streamingpath=${q(newStreamPath)}`, {
            method: "PUT",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}

export const updateNameStream = async (product, client, project, streamType, wellName, newStreamName) => {
    try {
        const response = await fetch(`${API_STREAMS}/changewellname/${product}/${client}/${project}/${streamType}/${wellName}?well_name_new=${q(newStreamName)}`, {
            method: "PUT",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}


export const resetStream = async (product, client, project, streamType, wellName, newStreamName) => {
    try {
        const response = await fetch(`${API_STREAMS}/resetstream/${product}/${client}/${project}/${streamType}/${wellName}`, {
            method: "PUT",
            headers: apiHeaders(),
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}


export const createStreamType = async (product, newStreamType, fields) => {
    try {
        const formData = new FormData();

        // flat {"column": "type"} object, as the workers read it; the API requires a .json file name
        formData.append("upload", new Blob([JSON.stringify(fields)], { type: "application/json" }), `cols_${product}_${newStreamType}.json`);
        const response = await fetch(`${API_STREAMS_ADMIN}/createstreamtype/${product}/${newStreamType}`, {
            method: "POST",
            headers: apiHeaders(),
            body: formData,
        });

        return await response.json();
    } catch (error) {
        throw new Error("Ha ocurrido un error con la carga de información");
    }
};


export const updateStreamType = async (product, streamType, fields) => {
    try {
        const formData = new FormData();

        // flat {"column": "type"} object, as the workers read it; the API requires a .json file name
        formData.append("upload", new Blob([JSON.stringify(fields)], { type: "application/json" }), `cols_${product}_${streamType}.json`);
        const response = await fetch(`${API_STREAMS_ADMIN}/modifystreamtype/${product}/${streamType}`, {
            method: "PUT",
            headers: apiHeaders(),
            body: formData
        });
        return await response.json();

    } catch (error) {
        throw new Error("A ocurrido un error con la carga de informacion")
    }
}






// Current columns configuration of a stream type: {columns: {name: "str"|"float"}, updated_at}
export const getStreamTypeConfig = async (product, streamType) => {
    const response = await fetch(`${API_STREAMS_ADMIN}/streamtype/${product}/${streamType}`, {
        method: "GET",
        headers: apiHeaders(),
    });
    return await response.json();
};
